import styled from '@emotion/styled';

interface ContainerProps {
  align: string;
}

interface WrapperProps {
  height: string;
  width: string;
}
export const Container = styled.div<ContainerProps>(
  {
    display: 'flex',
    pointerEvents: 'none',
  },
  props => ({
    justifyContent: props.align,
  })
);

export const Wrapper = styled.div<WrapperProps>(
  {
    width: '100%',
    maxHeight: '560px',
  },
  props => ({
    height: `${props.height}px`,
    maxWidth: `${props.width}px`,
  })
);

export const IframeElement = styled.iframe({
  width: '100%',
  height: '100%',
  title: 'YouTube video player',
  allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
});
